import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Tabs } from "antd";
import FeatherIcon from 'feather-icons-react';
import DetailsTab from './DetailTab.json';
import Reports from './CamEmailTrack';
import Account360 from '../../Reports/Account360';
import Task from '../../TablesAndTimelines/TaskTable';
import Lead from '../../TablesAndTimelines/LeadTable';
import Deal from '../../TablesAndTimelines/DealTable';
import Case from '../../TablesAndTimelines/CaseTable';
import CallLog from '../../TablesAndTimelines/CallLog';
import Notes from '../../TablesAndTimelines/NotesTable';
import Email from '../../TablesAndTimelines/EmailTable';
import ChildCase from '../../TablesAndTimelines/ChildCase';
import Followers from '../../TablesAndTimelines/Followers';
import Account from '../../TablesAndTimelines/AccountTable';
import Contact from '../../TablesAndTimelines/ContactTable';
import Meeting from '../../TablesAndTimelines/MeetingTable';
import Targeting from '../../TablesAndTimelines/TargetingPage';
import SalesDoc from '../../TablesAndTimelines/SalesDocsForDeal';
import CommentsPage from '../../TablesAndTimelines/CommentsPage';
import Activity from '../../TablesAndTimelines/ActivityTimeline';
import Related from '../../TablesAndTimelines/RelatedItemForDeal';
import ChildCampaign from '../../TablesAndTimelines/ChildCampaign';
import { Button } from '../../../../components/buttons/buttons';
import {
    ResourceIcon, CompetitionIcon, AccountsIcon, ActivityIcon, CalendarIcon, CallLogIcon,
    CaseIcon, ContactIcon, DealIcon, EmailIcon, LeadIcon, NotesIcon, TaskIcon, ChildCaseIcon,
    FollowersIcon, SalesDocsIcon, ReportsIcon, TargetIcon, CarePlanIcon, MedicationIcon, ReassesmentIcon,
    EmailAnyltsIcon
} from "../../../../components/Icons/Icons";

const { TabPane } = Tabs;

const RelatedTab = ({
    EntityType, UrlId, NacTrigger, setNaCTrigger, profile, emailactiontype,
    disabledData, displayData, disabledData2, currencySettings, trigger,
    allLead, allContact, getCampaignData, ownerId, RunCampaign, isButtonEnabled, loading
}) => {
    const [activeTab, setActiveTab] = useState("1");
    const [openReport, setOpenReport] = useState(false);
    const openSalesReport = () => setOpenReport(!openReport);
    const [openEmailTrack, setOpenEmailTrack] = useState(false);
    const openTacking = () => setOpenEmailTrack(!openEmailTrack);
    const operations = (EntityType === "Account" || EntityType === "Campaign")
        ? {
            right: (
                (EntityType === "Campaign" && displayData?.isMailSent !== "Yes") ?
                    <Button className="button_outlined" size="small" style={{ marginBottom: 15 }} onClick={() => RunCampaign()} disabled={!isButtonEnabled || loading} loading={loading}>
                        <span style={{ display: "flex", alignItems: "center", gap: 5 }}><EmailIcon />  Send Campaign Emails</span>
                    </Button >
                    :
                    <Button className='reportbutton_outlined' size="small" style={{ marginBottom: 15 }} onClick={EntityType === "Campaign" ? () => openTacking() : () => openSalesReport()}>
                        {EntityType === "Campaign" ?
                            <span style={{ display: "flex", alignItems: "center", gap: 5 }}><EmailAnyltsIcon />  Email Analytics Report</span> :
                            <span style={{ display: "flex", alignItems: "center", gap: 5 }}><ReportsIcon />  Sponsor 360</span>}
                    </Button >
            )
        }
        : {};

    const tabIconMap = {
        Activity: <ActivityIcon classname="custom-iconTab" size={16} />,
        Care: <CarePlanIcon classname="custom-iconTab" size={20} />,
        Medication: <MedicationIcon classname="custom-iconTab" size={16} />,
        Goal: <ReassesmentIcon classname="custom-iconTab" size={16} />,
        Reassessment: <TaskIcon classname="custom-iconTab" size={16} />,
        Email: <EmailIcon classname="custom-iconTab" size={16} />,
        Meeting: <CalendarIcon classname="custom-iconTab" size={16} />,
        Task: <TaskIcon classname="custom-iconTab" size={16} />,
        Case: <CaseIcon classname="custom-iconTab" size={16} />,
        CallLogs: <CallLogIcon size={16} classname="custom-iconTab" />,
        Notes: <NotesIcon size={16} classname="custom-iconTab" />,
        Deals: <DealIcon size={16} classname="custom-iconTab" />,
        Contacts: <ContactIcon size={16} classname="custom-iconTab" />,
        ContactPersons: <ContactIcon size={16} classname="custom-iconTab" />,
        Competition: <CompetitionIcon size={16} classname="custom-iconTab" />,
        Leads: <LeadIcon size={16} classname="custom-iconTab" />,
        Accounts: <AccountsIcon size={16} classname="custom-iconTab" />,
        Related: <ResourceIcon size={16} classname="custom-iconTab" />,
        Cases: <CaseIcon size={16} classname="custom-iconTab" />,
        ChildCases: <ChildCaseIcon size={16} classname="custom-iconTab" />,
        Followers: <FollowersIcon size={16} classname="custom-iconTab" />,
        SalesDocs: <SalesDocsIcon size={16} classname="custom-iconTab" />,
        Comments: <FeatherIcon icon="message-square" size={20} className="custom-iconTab" />,
        Targeting: <TargetIcon size={16} classname="custom-iconTab" />,
        Reports: <ReportsIcon size={16} classname="custom-iconTab" />,
    };
    const getTabLabel = (tab, displayData) => {
        const { label: originalLabel, value } = tab;
        let label = originalLabel;
        let icon = tabIconMap[value];
        if (value === "RelatedTo") {
            const taskType = displayData?.task_type_name;
            if (taskType === "Lead") {
                label = "Related Leads";
                icon = tabIconMap.Leads;
            } else if (taskType === "Contact") {
                label = "Related Contacts";
                icon = tabIconMap.Contacts;
            } else if (taskType === "Account") {
                label = "Related Accounts";
                icon = tabIconMap.Accounts;
            } else if (taskType === "Deal") {
                label = "Related Deals";
                icon = tabIconMap.Deals;
            } else if (taskType === "Case") {
                label = "Related Cases";
                icon = tabIconMap.Cases;
            }
        }
        return (
            <span style={{ display: 'flex', alignItems: 'center' }}>
                {icon}
                {label}
            </span>
        );
    };
    const memoUrlId = useMemo(
        () => UrlId,
        [UrlId?.[0], UrlId?.[1]]
    );
    const entityId = memoUrlId?.[1];
    return (
        <>
            <Account360 currency={openReport} setCurrency={openSalesReport} DataId={entityId} UserId={ownerId} />
            <Reports openEmailTrack={openEmailTrack} setOpenEmailTrack={setOpenEmailTrack} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailactiontype} />
            <Tabs activeKey={activeTab}
                onChange={(key) => setActiveTab(key)}
                className="Details-Tab-Center"
                tabBarExtraContent={operations}>
                {DetailsTab[EntityType].map((tab) => (
                    <TabPane tab={getTabLabel(tab, displayData)} key={tab.key}>
                        {tab.value === "Followers" && <Followers displayData={displayData} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "ChildCases" && <ChildCase displayData={displayData} refreshTrigger={activeTab} tabKey={tab.key} page="Child" />}
                        {tab.value === "Task" && <Task UrlId={memoUrlId} NacTrigger={NacTrigger} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Comments" && <CommentsPage displayData={displayData} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "ChildCampaign" && <ChildCampaign displayData={displayData} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Case" && <ChildCase UrlId={memoUrlId} displayData={displayData} refreshTrigger={activeTab} tabKey={tab.key} page="Case" />}
                        {tab.value === "RelatedTo" && (<>
                            {displayData?.task_type_name === "Lead" && <Lead UrlId={memoUrlId} refreshTrigger={activeTab} tabKey={tab.key} />}
                            {displayData?.task_type_name === "Deal" && <Deal UrlId={memoUrlId} EntityType={EntityType} refreshTrigger={activeTab} tabKey={tab.key} />}
                            {displayData?.task_type_name === "Case" && <Case UrlId={memoUrlId} EntityType={EntityType} refreshTrigger={activeTab} tabKey={tab.key} />}
                            {displayData?.task_type_name === "Contact" && <Contact UrlId={memoUrlId} EntityType={EntityType} refreshTrigger={activeTab} tabKey={tab.key} />}
                            {displayData?.task_type_name === "Account" && <Account UrlId={memoUrlId} EntityType={EntityType} refreshTrigger={activeTab} tabKey={tab.key} />}
                        </>)}
                        {tab.value === "Related" && <Related displayData={displayData} currencySettings={currencySettings} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Notes" && <Notes UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "SalesDocs" && <SalesDoc displayData={displayData} currencySettings={currencySettings} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "CallLogs" && <CallLog UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Competition" && <Account UrlId={memoUrlId} EntityType={EntityType} displayData={displayData} page="Deal" refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Meeting" && <Meeting UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} type="Collaspe" refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "ContactPersons" && <Contact UrlId={memoUrlId} EntityType={EntityType} displayData={displayData} disabledData2={disabledData2} page="Deal" refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Email" && <Email UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailactiontype} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Activity" && <Activity trigger={trigger} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} emailactiontype={emailactiontype} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Contacts" && <Contact UrlId={memoUrlId} EntityType={EntityType} displayData={displayData} disabledData2={disabledData2} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Deals" && <Deal UrlId={memoUrlId} disabledData={disabledData} EntityType={EntityType} displayData={displayData} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Targeting" && <Targeting allLead={allLead} allContact={allContact} getCampaignData={getCampaignData} displayData={displayData} setNaCTrigger={setNaCTrigger} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Care" && <Email UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailactiontype} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Medication" && <Email UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailactiontype} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Reassessment" && <Email UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailactiontype} refreshTrigger={activeTab} tabKey={tab.key} />}
                        {tab.value === "Goal" && <Email UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailactiontype} refreshTrigger={activeTab} tabKey={tab.key} />}
                    </TabPane>
                ))}
            </Tabs>
        </>
    );
};
RelatedTab.propTypes = {
    EntityType: PropTypes.string.isRequired,
    disabledData: PropTypes.bool.isRequired,
    disabledData2: PropTypes.bool.isRequired,
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    emailactiontype: PropTypes.object.isRequired,
    currencySettings: PropTypes.object.isRequired,
    displayData: PropTypes.object.isRequired,
    trigger: PropTypes.string.isRequired,
    allLead: PropTypes.array.isRequired,
    allContact: PropTypes.array.isRequired,
    getCampaignData: PropTypes.func.isRequired,
    ownerId: PropTypes.number.isRequired,
    RunCampaign: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    isButtonEnabled: PropTypes.bool.isRequired,
};
export default React.memo(RelatedTab)
